<div class="card h-100 horse-card">
  <!-- Horse Image -->
  <div class="horse-image-container position-relative">
    @if (horse.image_url && horse.image_url.length > 0) {
      <img [src]="horse.image_url" class="card-img-top horse-image" [alt]="horse.name"/>
    } @else {
      <div class="horse-image-placeholder d-flex align-items-center justify-content-center">
        <i class="fa-solid fa-horse fs-1 text-muted"></i>
      </div>
    }

    <!-- Gender Badge -->
    <div class="position-absolute top-0 end-0 m-3">
      <span class="badge badge-lg" [ngClass]="getGenderBadgeClass()">
        {{ getHorseGenderLabel(horse.gender) }}
      </span>
    </div>
  </div>

  <div class="card-body d-flex flex-column p-4">
    <!-- Horse Name -->
    <h3 class="card-title fw-bold fs-4 mb-1">{{ horse.name }}</h3>
    <div class="text-muted fs-7 mb-4">{{ horse.breed || ('horseCard.unknownBreed' | translate) }}</div>

    <!-- Horse Details -->
    <div class="mb-4">
      <div class="row g-3">
        <!-- Left Column -->
        <div class="col-6">
          <!-- Birth Year -->
          @if (horse.date_of_birth) {
            <div class="d-flex align-items-start mb-3">
              <div class="detail-icon">
                <i class="fa-solid fa-cake-candles text-primary"></i>
              </div>
              <div>
                <div class="text-muted fs-8">{{ 'horseCard.born' | translate }}</div>
                <div class="fw-semibold fs-7">{{ horse.date_of_birth | date:'yyyy' }}</div>
              </div>
            </div>
          }

          <!-- Color -->
          @if (horse.color) {
            <div class="d-flex align-items-start">
              <div class="detail-icon">
                <i class="fa-solid fa-palette text-primary"></i>
              </div>
              <div>
                <div class="text-muted fs-8">{{ 'horseCard.color' | translate }}</div>
                <div class="fw-semibold fs-7">{{ horse.color }}</div>
              </div>
            </div>
          }
        </div>

        <!-- Right Column -->
        <div class="col-6">
          <!-- Registry -->
          <div class="d-flex align-items-start mb-3">
            <div class="detail-icon">
              <i class="fa-solid fa-id-card text-primary"></i>
            </div>
            <div>
              <div class="text-muted fs-8">{{ 'horseCard.registry' | translate }}</div>
              <div class="fw-semibold fs-7">{{ getRegistryLabel(horse.horse_registry_id) }}</div>
            </div>
          </div>

          <!-- Vaccination Status -->
          @if (horse.next_vaccination_date) {
            <div class="d-flex align-items-start">
              <div class="detail-icon">
                <i class="fa-solid fa-syringe" [ngClass]="isVaccinationExpired() ? 'text-danger' : 'text-success'"></i>
              </div>
              <div>
                <div class="text-muted fs-8">{{ 'horseCard.nextVaccination' | translate }}</div>
                <div class="fw-semibold fs-7" [ngClass]="isVaccinationExpired() ? 'text-danger' : ''">
                  {{ horse.next_vaccination_date | date:'dd.MM.yyyy' }}
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="mt-auto d-flex gap-2 button-row">
      <app-button
        [label]="'horseCard.edit' | translate"
        [variant]="'primary'"
        [iconClass]="'fa fa-edit'"
        class="button-half"
        (clicked)="emitEditHorseClick()"
      />
      <div class="dropdown">
        <button
          class="btn btn-light btn-icon"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i class="fa fa-ellipsis-v"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
          <li>
            <a class="dropdown-item text-danger" (click)="emitDeleteHorseClick()">
              <i class="fa fa-trash me-2"></i>{{ 'horseCard.delete' | translate }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
